module.exports = "/fonts/opensanslightitalic.woff2";